export default "__VITE_ASSET__BkDrjxGe__"